export const decryptShopifyId = (id: string) => Number(id.split('/').pop());
